import React from 'react'
import AiDetailContent from './AiDetailContent'
import AiRelatedPost from './AiRelatedPost'


export default function AiDetails({initialData}) {
  return (
    <>
      <AiDetailContent  initialData={initialData?.detailpage} />
      <AiRelatedPost initialData={initialData?.listpage}  />
    </>
  )
}


